<!-- 项目文件 -->
<template>
<div>
    <Header1 :img="bgImg"></Header1>
    <div class="pt30 pb20 w1200 mauto">
        <div class="textc mt20 mb20 ">
            <p class="fs36 c333 disinblock posre">
                <span class="border-bottom1">
                    人才招聘
                </span>
            </p>
        </div>
        <div class="pt10 pb15  posre">
            <ul class="disinblock w100p overflow">
                <li class="   border2e w48p pt30 mt10 mb10 disinblock floatl box ml12 mr12" v-for="(item,index) in message" :key="index">
                    <div class=" pl30 pr30">
                        <p class="pt4 pb4">
                            <span class="c1f8 fbold fs22"> {{item.title}} </span>
                            <span class="c999 fs14 pl5"> {{item.time}} 发布</span>
                        </p>
                        <p class="pt4 pb4 overflow ">
                            <span class="disinblock floatl">
                                <span class="c666 fbold fs20 pr5">招 {{item.num}} 人</span>
                                <span class="c666 fs14 pl12 pr12 "> {{item.address}} </span>
                                <span class="c666 fs14 pl12 pr12 border2r border2l"> {{item.axperience}} </span>
                                <span class="c666 fs14 pl12 pr12"> {{item.aducation}} </span>
                            </span>
                            <span class="floatr fs20 cf399 disinblock">
                                {{item.salary}} /月
                            </span>
                        </p>
                    </div>
                    <div class="bgf6fa  pt15 pb15 mt20 overflow border2t  pl30 pr30">
                        <span class="fs14 c333 disinblock floatl">岗位职责</span>
                        <span  class="fs14 c1f8 floatr disinblock cursor" @click="open(index)" v-if="isShow==1 && indexTy==index">收起查看 ∨</span>
                        <span class="fs14 c1f8 floatr disinblock cursor" @click="open(index)" v-else>展开查看 ∨</span>
                    </div>
                    <div class="border2e posab zindex1 bgf6fa  ml0 mr0" style="width: 47.8%;margin-left: -1px;" v-if="isShow==1 && indexTy==index">
                       <div class="pl30 pr30 pt20 pb20">
                            <p class="fs16 c333 pt5 pb5">职位信息</p>
                            <p class="fs14 c666 pt5 pb5" v-for="(v,i) in item.detail" :key="index">
                                 {{i+1}}、{{v}}
                            </p>
                       </div>
                    <div class="pl30 pr30 pt20 pb20">
                        <p class="fs16 c333 pt5 pb5">岗位职责</p>
                        <p class="fs14 c666 pt5 pb5" v-for="(vv,ii) in item.detail2" :key="index">
                            {{ii+1}}、{{vv}}
                        </p>
                    </div>
                    </div>
                </li>
               
            </ul>
        </div>
    
    </div>
    <Footer></Footer>  
</div>
</template>

<script>
    import Header1 from '@/components/Header1'
    import Footer from '@/components/Footer'
    export default {
        data() {
            return {
                bgImg: require('../../public/img/img160.png'),
                isShow: 0,
                indexTy: -1,
                message: [{
                    title: '渠道销售经理（周末双休+五险一金）',
                    time: '06-18',
                    num: 2,
                    address: '南京',
                    axperience: '2年经验',
                    aducation: ' 大专',
                    salary: '1-1.5万',
                    detail: [
                        '独立开发客户，完成前期客户沟通工作，按照专业、标准化的销售流程与目标客户进行交流',
                        ' 准确把握并分析客户需求，为客户提供最具针对性的产品及服务，促进客户达成销售.',
                        ' 负责合同条款的谈判及合同签定事宜。',
                        '指导并带领团队，完成销售任务。',
                        '参与内部分享机制，交流成功经验，培养团队。'
                    ],
                    detail2: [
                        ' 大专以上学历，市场营销、广告、传媒等相关专业。',
                        ' 3年以上互联网广告销售经验，有互联网广告客户资源者优先。',
                        ' 对互联网营销领域有浓厚的兴趣，喜爱销售工作。',
                        ' 有敏锐的市场洞察力，具备强烈的市场开拓精神和成功欲望。',
                    ],
                }, {
                    title: '渠道销售代表（无责底薪+五险一金）',
                    time: '06-18',
                    num: 5,
                    address: '南京',
                    axperience: '应届生',
                    aducation: '高中',
                    salary: '0.4-1万',
                    detail: [
                        '协助收集、整理、归纳市场行情、价格，客源等信息资料，提出分析报告，为部门业务人员、领导决策提供参考。',
                        '协助招商主管负责公司项目的招商工作。',
                        '定期向招商主管（主办）汇报工作情况和客户跟踪情况，定期进行工作总结，提高工作计划性和有效性。',
                        '严格执行公司各项规章制度，服从管理。',
                        '具备较强的组织协调及沟通交际能力，勤奋敬业。',
                    ],
                    detail2: [
                        ' 应届毕业生，大专以上学历，专业不限；',
                        ' 自信活泼开朗，热爱互联网行业；',
                        ' 工作稳重踏实，积极主动，学习力强。',
                        ' 公司可签订三方协议；能力突出者，毕业后可直接转正！',
                    ],
                }, {
                    title: '营销策划推广',
                    time: '06-18',
                    num: '若干',
                    address: '南京',
                    axperience: '在校生/应届生',
                    aducation: '大专',
                    salary: '4-6千',
                    detail: [
                        '负责公司项目各阶段的营销策略计划及策划事项对接工作，承担营销方案的撰写并制定、参与或协助上级执行政策及制度；',
                        '负责项目与产品包装策划（含品牌、营销）与执行，提升营销投入产出比；',
                        '负责公司自媒体与合作渠道的宣传、推广工作，通过各种方式来提高访问量及转化率；',
                        '负责官方微信公众平台的日常运营管理、信息发布与维护，提高关注度、热度、增加销量，并对微信公众号的流量和活跃度负责；',
                        '分析并发掘用户需求、提高产品信息的传播量，提高产品在目标客户群中的知名度；',
                        '负责公司相关新闻报道及各类宣传策划方案文字撰稿；',
                        '负责行业竞品的收集，分析；',
                    ],
                    detail2: [
                        ' 大专及以上学历，营销或经济管理、广告学、新闻类或中文类专业优先考虑；',
                        ' 大学本科毕业，在校期间有社团或学生会服务工作优先；',
                        '有独立完成项目活动文案的撰写能力；',
                        '文字功底扎实；具有流畅的沟通和语言表达能力；',
                        '具备熟练运作PPT、WORD、EXCEL等办公软件的能力；',
                        '学习能力强，责任感强，擅长人际沟通和团队合作。',
                    ],
                }, {
                    title: '渠道销售经理（周末双休+五险一金）',
                    time: '06-18',
                    num: 2,
                    address: '南京',
                    axperience: '2年经验',
                    aducation: '高中',
                    salary: '3-8',
                    detail: [
                        '独立开发客户，完成前期客户沟通工作，按照专业、标准化的销售流程与目标客户进行交流。',
                        ' 准确把握并分析客户需求，为客户提供最具针对性的产品及服务，促进客户达成销售。',
                        ' 负责合同条款的谈判及合同签定事宜。',
                        '参与内部分享机制，交流成功经验，培养团队。',
                    ],
                    detail2: [
                        '大专以上学历，市场营销、广告、传媒等相关专业。',
                        ' 3年以上互联网广告销售经验，有互联网广告客户资源者优先。',
                        '对互联网营销领域有浓厚的兴趣，喜爱销售工作。',
                        '文字功底扎实；具有流畅的沟通和语言表达能力；',
                        '具备熟练运作PPT、WORD、EXCEL等办公软件的能力；',
                        ' 有敏锐的市场洞察力，具备强烈的市场开拓精神和成功欲望。',
                    ],
                }, {
                    title: '销售代表（4-8k的无责任底薪，周末双休）',
                    time: '06-18',
                    num: 5,
                    address: '南京',
                    axperience: '应届生',
                    aducation: '高中',
                    salary: '4-8',

                    detail: [
                        '协助收集、整理、归纳市场行情、价格，客源等信息资料，提出分析报告，为部门业务人员、领导决策提供参考。',
                        '协助招商主管负责公司项目的招商工作。',
                        '定期向招商主管（主办）汇报工作情况和客户跟踪情况，定期进行工作总结，提高工作计划性和有效性。',
                        '按照公司下达的招商任务编写年度、月度招商计划书并负责具体实施。',
                        '严格执行公司各项规章制度，服从管理。',
                        '具备较强的组织协调及沟通交际能力，勤奋敬业。'
                    ],
                    detail2: [
                        '应届毕业生，大专以上学历，专业不限；',
                        '自信活泼开朗，热爱互联网行业；',
                        '工作稳重踏实，积极主动，学习力强。',
                        '公司可签订三方协议；能力突出者，毕业后可直接转正！'
                    ],
                }, {
                    title: '校园推广经理',
                    time: '06-18',
                    num: '若干',
                    address: '南京',
                    axperience: '在校生/应届生 ',
                    aducation: '大专 ',
                    salary: '2.5-5',
                    detail: [
                        '负责校园渠道活动推广；',
                        '完成校园项目对接与沟通，活动执行；',
                        '负责对接校园领事，招募、组建校园团队，提升推广业绩；',
                        '对制定可行的线上线下校园推广宣传方案的落地执行；',
                        '建立校园推广渠道，配合其他部门工作。'

                    ],
                    detail2: [
                        '必须为在校学生；',
                        '有过市场专员，销售或地推相关工作经验优先录取；',
                        '担任学生会工作优先录取；',
                        '优秀的外联与公关能力，丰富的校园渠道资源和客户资源，具备解决突发事件的能力；',
                        '工作热情主动，具有一定策划思维，富有创新意识，具有极强的团队协作意识和服务意识；',
                        '有团队组建以及管理经验，能带有领校园团队完成校园推广工作，做好关系维护。',
                    ],
                }, {
                    title: '线下渠道推广',
                    time: '05-14',
                    num: '若干',
                    address: '南京',
                    axperience: '在校生/应届生 ',
                    aducation: '大专 ',
                    salary: '4-8',
                    detail: [
                        '协助运营、市场部门营销推广计划，进行业务拓展。',
                        '负责客户的信息数据收集及回访工作。',
                        '负责进行各类营销活动推广执行，并做好活动转化，信息收集整理工作。',
                        '完成主管安排临时安排的工作。'

                    ],
                    detail2: [
                        '对市场推广工作抱有热情，本岗位接受实习生。',
                        '良好的表达能力及沟通协调能力，公关能力强，能够承受工作压力。',
                        '良好的团队协作精神，勤奋、踏实、责任心强。',
                        '有过相关经验优先考虑。'
                    ],
                }]
            };
        },
        components: {
            Header1,
            Footer,
        },
        methods: {
            open(id) {
                this.indexTy = id;
                this.isShow = !this.isShow;
            }
        },
        created() {

        },
        mounted() {

        },
    }
</script>
<style scoped>

</style>